import React from "react";
import { CoordinateSystem } from "./CoordinateSystem";
import { laengeDisplayPxMinimum } from "./Zaunlinien";
import { Stromkabel } from "../../arrangement/Stromkabel";
import { Aufbau } from "../../arrangement/Aufbau";

export function getKabelColor(aufbau: Aufbau) {
  return aufbau?.color == null ? "#000000" : "#" + aufbau.color.getHexString();
}

export function Stromkabellinie({ cs, kabel }: { cs: CoordinateSystem; kabel: Stromkabel }) {
  const pointWidth = cs.lengthToScreen(0.1);
  const lineWidth = cs.lengthToScreen(0.08);

  const wegpunkte = kabel.pfad.flatMap((p) => cs.pointToScreen(p));
  const anschlusspunkte = kabel.lichtAnschlüsse.map((p) => cs.pointToScreen(p));
  const selectedClassName = "";
  const zoomZuKleinFürDetails = cs.lengthToScreen(kabel.länge) < laengeDisplayPxMinimum;
  const punkteZuPolygon = (punkte) =>
    punkte.map((p) => p.x.toFixed(1) + "," + p.y.toFixed(1)).join(" ");
  const color = getKabelColor(kabel.trafo);

  console.log({ anschlusspunkte });
  if (zoomZuKleinFürDetails) {
    return null;
  }
  return (
    <>
      <polyline
        points={punkteZuPolygon(wegpunkte)}
        strokeWidth={lineWidth.toFixed(1)}
        className={"svg-kabel " + selectedClassName}
        stroke={color}
      />
      {anschlusspunkte.map((p, i) => (
        <circle
          key={i}
          r={pointWidth.toFixed(1)}
          cx={p.x.toFixed(1)}
          cy={p.y.toFixed(1)}
          className={"svg-kabel-kreis " + selectedClassName}
          fill={color}
        />
      ))}
    </>
  );
}
